export default __webpack_public_path__ + "static/media/png.8224bee5.svg";